<template>
	<v-dialog v-model="commodity_edit_form_dialog_status" persistent >
	    <v-card>
		    <v-card-title>
		      <span class="text-h5">Edit Form</span>
		    </v-card-title>
		    <v-card-text>
			    <v-container>
			      	<v-form ref="form" id="commodity_edit_form_dialog" v-model="valid" lazy-validation @submit.prevent lazy-validation>
				        <v-row> 
					        <v-col cols="12" sm="6" md="4">
					            <label>Account Owner</label>
					            <v-select
					                ref="account_owner_name"
					                name="account_owner_name"
					                v-model="selected_account_owner_name"
					                :items="account_owner_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('account_owner_name', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{account_owner_warning_msg}}</p>
					        </v-col>


							<v-col cols="12" sm="6" md="4">
					            <label>Exchange</label>
					            <v-select
					                ref="exchange"
					                name="exchange"
					                v-model="selected_exchange"
					                :items="exchange_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('exchange', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{exchange_warning_msg}}</p>
					        </v-col>


							<v-col cols="12" sm="6" md="4">
					            <label>Commodity Name</label>
					            <v-select
					                ref="commodity_name"
					                name="commodity_name"
					                v-model="selected_commodity_name"
					                :items="commodity_name_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('commodity_name', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{commodity_name_warning_msg}}</p>
					        </v-col>


							<v-col cols="12" sm="6" md="4">
					            <label>Location Name</label>
					            <v-select
					                ref="location_name"
					                name="location_name"
					                v-model="selected_location_name"
					                :items="location_name_items"
					                item-value="name"
					                item-text="name"
					                @change="removeError('location_name', $event)"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{location_name_warning_msg}}</p>
					        </v-col>

							<v-col cols="12" sm="6" md="4">
					          	<label>Unit</label>
					            <v-text-field name="units" ref="units" v-model ="units"></v-text-field>
					        </v-col>
						
							<v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_1_select_box_status">Nominee 1 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_1')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 1 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_1')">remove dropdown</a></label>
					            <v-text-field name="nominee_1" ref="nominee_1" v-model="selected_nominee_1" v-if="!nominee_1_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_1"
					                name="nominee_1"
					                v-model="selected_nominee_1"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>

							<v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_2_select_box_status">Nominee 2 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_2')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 2 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_2')">remove dropdown</a></label>
					            <v-text-field name="nominee_2" ref="nominee_2" v-model="selected_nominee_2" v-if="!nominee_2_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_2"
					                name="nominee_2"
					                v-model="selected_nominee_2"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
							<v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_3_select_box_status">Nominee 3 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_3')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 3 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_3')">remove dropdown</a></label>
					            <v-text-field name="nominee_3" ref="nominee_3" v-model="selected_nominee_3" v-if="!nominee_3_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_3"
					                name="nominee_3"
					                v-model="selected_nominee_3"
					                :items="nominee_items"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
				        </v-row>
				    </v-form>    
			    </v-container>
		    </v-card-text>
		    <v-card-actions>
		      <v-spacer></v-spacer>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="close"
		      >
		        Cancel
		      </v-btn>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="save"
		      >
		        Save
		      </v-btn>
		    </v-card-actions>
	    </v-card>
	</v-dialog>
</template>
<script>
    import axios from "axios";
    import { Auth } from "aws-amplify";
	import Datepicker from 'vuejs-datepicker';
    export default {
		components: {
		  Datepicker,
		},
	  	props: ['commodity_edit_form_dialog_status', 'get_commodity_edit_form_data', 'get_member_list' , 'get_uploaded_commodity_detail_master_data_list', 'get_uploaded_commodity_master_data_list'],
	  	data: function () {
		    return { 
				account_owner_name:'',
                selected_account_owner_name:'',
				account_owner_items:[],
				account_owner_warning_msg:'',
				account_owner_warning_status:false,
				commodity_name:'',
                selected_commodity_name:'',
				commodity_name_items:[],
				commodity_name_warning_msg:'',
				commodity_name_warning_status:false,

				location_name:'',
                selected_location_name:'',
				location_name_items:[],
				location_name_warning_msg:'',
				location_name_warning_status:false,
				exchange:'',
                selected_exchange:'',
				exchange_items:[{id:'MCX', name:'MCX'}, {id:'NCDX', name:'NCDX'}],
				exchange_warning_msg:'',
				exchange_warning_status:false,
				units:'',
				nominee_1:'',
				selected_nominee_1:'',
				nominee_2:'',
				selected_nominee_2:'',
				nominee_3:'',
				selected_nominee_3:'',
				nominee_items:[],
				amount_invested:'',
				nominee_1_select_box_status:false,
				nominee_2_select_box_status:false,
				nominee_3_select_box_status:false,
			    valid:null,
				user_name:''
		    }
		},

	    created (){
			this.$loading(true)
			setTimeout(()=>{
				Auth.currentAuthenticatedUser({
					bypassCache: false
				}).then(user => {	
					this.user_name = user.attributes["custom:name"];
					let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
					let formdata  = new FormData();
					formdata.append("aws_cognito_id", cognito_idp);
					formdata.append("user_name", user.attributes["custom:name"]);
					axios.post( process.env.VUE_APP_ROOT_API+'get-member-list',
					formdata,{}
					).then((response) => {
						let owner_error_cnt  = 'yes';
						response.data.data.forEach(owner_detail => {
							this.account_owner_items.push({'id':owner_detail.name, 'name':owner_detail.name});
							if(this.get_commodity_edit_form_data.owner == owner_detail.name){
								this.selected_account_owner_name = owner_detail.name
								owner_error_cnt = 'no';
							}
						})
						if(owner_error_cnt == 'yes'){
							this.account_owner_warning_msg  = 'Uploaded owner name ('+this.get_commodity_edit_form_data.owner+') is not found in member list. Kindly choose from dropdown';
						}
					}).catch(() => {
						this.$loading(false);
					});
				})
				this.nominee_items              = this.account_owner_items;
				this.units                      = this.get_commodity_edit_form_data.units;
				this.selected_commodity_name    = this.get_commodity_edit_form_data.commodity_name;
				this.selected_exchange          = this.get_commodity_edit_form_data.exchange;
				this.setCommodityMasterData();
				this.setLocationMasterData();
				this.$loading(false)
			}, 3000);
			
	    },

	    methods: {
	    	removeError(type, type_val){
		        if(type == 'exchange'){
					this.setCommodityMasterData();	
		            this.exchange_warning_msg = ''
		        }
		        else if(type == 'account_owner_name'){
		            this.account_owner_warning_msg = ''
		        }
				else if(type == 'commodity_name'){
					this.setLocationMasterData();
                    this.commodity_name_warning_msg = ''
				}
				else if(type == 'location_name'){
                    this.location_name_warning_msg = ''
				}
		    },

		    close(){
                this.$emit('getCommodityUpdatedFormData', false)
		    },

		    save(e){
				let is_form_valid  = true;
                this.getFormData = document.querySelector("#commodity_edit_form_dialog");
				
				if(this.getFormData.commodity_name.value ==''){
                    this.commodity_name_warning_msg = "Choose Valid Commodity From List";
					is_form_valid = false;
				}
				if(this.getFormData.exchange.value ==''){
                   this.exchange_warning_msg = "Choose valid Exchange from list";
				   is_form_valid  = false;
				}
				if(this.getFormData.account_owner_name.value ==''){
                   this.account_owner_name_warning_msg = "Choose Valid Account Owner Name from list";
				   is_form_valid  = false;
				}
				if(this.getFormData.location_name.value ==''){
                   this.location_name_warning_msg = "Choose Valid Account Owner Name from list";
				   is_form_valid  = false;
				}
				if(is_form_valid  == true){
					let form_array_object = {'location' :this.getFormData.location_name.value, 
											'exchange':this.getFormData.exchange.value, 
											'units':this.getFormData.units.value,
											'owner':this.getFormData.account_owner_name.value, 
											'nominee_1':this.getFormData.nominee_1.value,
											'nominee_2':this.getFormData.nominee_2.value,
											'nominee_3':this.getFormData.nominee_3.value,
											'commodity_name':this.getFormData.commodity_name.value,
											'is_commodity_name_valid':true,
											'is_location_valid':true,
											'is_account_owner_valid':true
			                        	};	 			
                    this.$emit('getCommodityUpdatedFormData', form_array_object);
				}
		    },

			setCommodityMasterData(){
				this.commodity_name_items=[];
				let commodity_name_warning_msg_cnt = 'yes'
				let c_exc = (this.selected_exchange=='MCX')?2:1;
                this.get_uploaded_commodity_master_data_list.forEach(commodity_name_detail => {
					if(c_exc == commodity_name_detail.type_id){
                        this.commodity_name_items.push({id:commodity_name_detail['name'], name:commodity_name_detail['name']})
						if(commodity_name_detail['name'] == this.get_commodity_edit_form_data.commodity_name){
							commodity_name_warning_msg_cnt = 'no';
						}
					}	
				})

				if(commodity_name_warning_msg_cnt == 'yes'){
                   this.commodity_name_warning_msg = 'Kindly choose data from above list';
				}
			},

			setLocationMasterData(){
				this.location_name_items=[];
				let location_name_warning_msg_cnt = 'yes';
                this.get_uploaded_commodity_master_data_list.forEach(commodity_name_detail => {
                    if(this.selected_commodity_name == commodity_name_detail.name){
                        this.get_uploaded_commodity_detail_master_data_list.forEach(commodity_detail => {
							if(commodity_name_detail.id == commodity_detail.commodity_id){
								if(commodity_detail['location'] != null && commodity_detail['location'] != ''){
									this.location_name_items.push({id:commodity_detail['location'], name:commodity_detail['location']})
									if(commodity_detail['location']==this.get_commodity_edit_form_data.location){
									   location_name_warning_msg_cnt = 'no';
									}
								}
							}
				        })
					}
				})
				if(location_name_warning_msg_cnt == 'yes'){
                   this.location_name_warning_msg = 'Kindly choose data from above list';
				}
			},

			chooseNominee(field_name){
	    		if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = true
	    		}
	    		else{

	    		}
	    	},

	    	typeNominee(field_name){
	    	    if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = false
	    		}
	    		else{

	    		}	
	    	},
	    }
    }
</script>